import * as React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ElectionState, ElectionStatus, Routes } from '../_generatedTypes.g';
import { DocumentTitle } from './DocumentTitle';
import { getTranslator } from '../Translator';
import { startEraseElection } from '../features/election/electionsSlice';
import { useAppSelector } from '../hooks';

export const ElectionAdminOptions = ((props: { election: ElectionState }) => {
    const { election: e } = props;
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);
    const language = useAppSelector(state => state.language);
    const t = getTranslator(language);
    const dispatch = useDispatch();

    return <ul>
        <li key={0}>
            <Link to={`/electioneditor/${e.ElectionId}`}>{t['Edit']}</Link>
        </li>
        {e.ElectionStatus === ElectionStatus.Closed && <>
            <li key={2}>
                <Link to={`/votingResult/${encodeURIComponent(e.ElectionId)}`}>{t['Voting result']}</Link>
            </li>
        </>}
        <li key={4}>
            <a href={Routes.Export.ExportElectionData(e.ElectionId)}>{t['Export election data']}</a>
        </li>
        {e.ElectionStatus === ElectionStatus.Closed && <>
            <li className="hanzeresults" key={5}>
                <a href={Routes.UitslagHanze.ExportZetelVerdeling(e.ElectionId)}>{t['Export seat distribution']}</a>
            </li>
        </>}
        {e.ElectionStatus !== ElectionStatus.Open && <>
            <li key={6}><a href="#" onClick={() => {
                if (confirm(t.eraseElectionWarning(e.Name))) {
                    startEraseElection(e, token, dispatch);
                }
            }}>{t['Delete']}</a></li>
        </>}
    </ul>
})

export const Admin = () => {
    const language = useAppSelector(state => state.language);
    const t = getTranslator(language);

    return <div>
        <h1>{t['Admin functionality']}</h1>
        <DocumentTitle title={t['Admin functionality']} />
        <p>
            <Link to="/votingRightsAdminManagement">{t['Import voting rights']}</Link>
        </p>
        <p>
            <a href={Routes.Elections.DownloadVoteResults}>{t['Download all past voting results (MsExcel)']}</a>
        </p>
        <p>
            <a href={Routes.Elections.DownloadTurnoutResults}>{t['Download turnout results (MsExcel)']}</a>
        </p>
        <p>
            <Link to="/electionHistory">{t['Usage history']}</Link>
        </p>
        <p>
            <a className="demoHistory" href={Routes.Elections.DownloadAllHistoryResults}>{t['Download all history (MsExcel)']}</a>
        </p>
        <p>
            <Link className="linkbutton" to={'/'}>{t['Back']}</Link>
        </p>
    </div>
}

